<template>
  <v-container fluid grid-list-sm>
    <h5 class="headline pt-1 pb-1" v-if="showTitle">Header</h5>
    <v-layout row wrap fill-height class="text-xs-left" align-center>
      <v-flex xs12 sm2>
        <date-picker
          customLabel="Start Date"
          :gt-date-string="startDate"
          :range-start="startDateRangeStart"
          :range-end="startDateRangeEnd"
          @onDateSelected="onStartDateSelected"
          :outlined="outlinedInputs"
        ></date-picker>
      </v-flex>
      <v-flex xs12 sm2>
        <date-picker
          customLabel="End Date"
          :gt-date-string="endDate"
          :range-start="endDateRangeStart"
          :range-end="endDateRangeEnd"
          @onDateSelected="onEndDateSelected"
          :outlined="outlinedInputs"
        ></date-picker>
      </v-flex>
      <v-flex xs12 mb-7 sm1>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="onMoveItineraryClick">
              <v-icon>mdi-arrow-split-vertical</v-icon>
            </v-btn>
          </template>
          <span>Move Itinerary</span>
        </v-tooltip>
      </v-flex>

      <v-flex xs12 sm1>
        <v-text-field
          label="Adults"
          type="number"
          v-model="noOfAdults"
          @change="onAdultsChange"
          :outlined="outlinedInputs"
          :min="minAdults"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm1>
        <v-text-field
          label="Children"
          type="number"
          @change="onChildrenChange"
          v-model="noOfChildren"
          :outlined="outlinedInputs"
          :min="minChildren"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm1>
        <v-text-field
          label="Infants"
          type="number"
          @change="onInfantsChange"
          v-model="noOfInfants"
          :outlined="outlinedInputs"
          :min="minInfants"
        ></v-text-field>
      </v-flex>
      <v-flex mb-7>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="onShowPaxUpdater" v-on="on">
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <span>Update Pax</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs12 sm3>
        <destination-list-select
          @onSelect="onDestinationSelect"
          :set-default="true"
          v-model="selectedDestinationId"
          required
          :outlined="outlinedInputs"
          hide-not-in-use
          :disabled="$store.getters.hasAccessTo('itineraries:lock_destination')"
        ></destination-list-select>
      </v-flex>
      <v-flex xs12 sm4 class="px-1">
        <agent-list-select
          @onSelect="onAgentSelect"
          :agent-id="selectedAgentId"
          :agent-name="agentName"
          :outlined="outlinedInputs"
          include-currency
          editable
          show-info
          @edit="onAgentEdit"
        ></agent-list-select>
      </v-flex>
      <v-flex xs12 sm4 class="px-1">
        <booked-by-list-select
          :agent-id="selectedAgentId"
          :booked-by-name="bookedByName"
          v-model="selectedBookedBy"
          @change="onBookedByChange"
          @input="onChange"
          :outlined="outlinedInputs"
        ></booked-by-list-select>
      </v-flex>

      <v-flex class="px-1">
        <itinerary-status-list-select
          label="Select Internal Itinerary Status"
          v-model="selectedInternalStatus"
          @input="onChange"
          :outlined="outlinedInputs"
          :editable="false"
        ></itinerary-status-list-select>
      </v-flex>
      <v-flex class="px-1" v-if="showLeadSource">
        <lead-source-list-select
          :outlined="outlinedInputs"
          multiple
          v-model="selectedLeadSourceIds"
          @input="onChange"
          :label="leadSourceLabel"
        ></lead-source-list-select>
      </v-flex>
      <v-flex xs12 sm4 class="px-1">
        <v-text-field
          label="Client Ref"
          :disabled="disableClientRef"
          v-model="selectedClientReference"
          @input="onChange"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4 class="px-1">
        <v-text-field
          label="Internal Ref"
          v-model="selectedInternalReference"
          @input="onChange"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm2 class="px-1">
        <department-list-select
          @onSelect="onDepartmentSelect"
          :department-name="department"
          :outlined="outlinedInputs"
        ></department-list-select>
      </v-flex>
      <v-flex xs12 sm2 class="px-1">
        <brand-list-select
          :label="brandLabel"
          :outlined="outlinedInputs"
          v-model="selectedBrand"
          @input="dispatchChange"
        ></brand-list-select>
      </v-flex>

      <div v-if="debug">
        <p>Min Adults: {{ minAdults }}</p>
        <p>Min Children: {{ minChildren }}</p>
        <p>Min Infants: {{ minInfants }}</p>
      </div>
    </v-layout>
    <move-itinerary
      :show="showMoveItinerary"
      @close="showMoveItinerary = false"
      @newStartDate="onNewStartDate"
      @move="onMove"
      :date="startDate"
    ></move-itinerary>
  </v-container>
</template>

<script>
var moment = require("moment");
import DestinationListSelect from "../../shared/DestinationListSelect";
import DatePicker from "../../shared/DatePicker";
import AgentListSelect from "../../shared/AgentListSelect";
import DepartmentListSelect from "../../shared/DepartmentListSelect";
import ItineraryStatusListSelect from "../../shared/ItineraryStatusListSelect";
import { datesAreDiffernt } from "../../../../helpers/";
import BookedByListSelect from "../../shared/BookedByListSelect";
import BrandListSelect from "../../shared/BrandListSelect";
import MoveItinerary from "./tools/MoveItinerary";
import ConfirmationDialogVue from "../../shared/ConfirmationDialog.vue";
import LeadSourceListSelect from "../../shared/LeadSourceListSelect.vue";
export default {
  name: "ItinearyBuilderDetails",

  props: {
    showTitle: {
      type: Boolean,
      default: () => true,
    },
    adults: {
      default: "2",
    },
    children: {
      default: "0",
    },
    infants: {
      default: "0",
    },
    departmentName: {
      type: String,
    },
    internalReference: {
      type: String,
    },
    clientReference: {
      type: String,
      default: () => "",
    },
    internalStatus: {
      type: String,
    },
    agentId: {
      type: String,
    },
    agentName: {
      type: String,
      default: () => "",
    },
    destinationId: {
      type: String,
      default: () => "",
    },
    inputStartDate: {
      type: String,
      default: () => null,
    },
    inputEndDate: {
      type: String,
      default: () => null,
    },
    bookedById: {
      type: String,
    },
    bookedByName: {
      type: String,
    },
    brand: {
      type: String,
      default: () => null,
    },
    leadSourceIds: {
      type: Array,
      default: () => [],
    },
    minAdults: {
      type: Number,
      default: () => 0,
    },
    minChildren: {
      type: Number,
      default: () => 0,
    },
    minInfants: {
      type: Number,
      default: () => 0,
    },
  },

  components: {
    DestinationListSelect,
    DatePicker,
    AgentListSelect,
    DepartmentListSelect,
    ItineraryStatusListSelect,
    BookedByListSelect,
    BrandListSelect,
    MoveItinerary,
    LeadSourceListSelect,
  },
  data() {
    return {
      debug: false,
      keepDatesDuration: false,
      noOfAdults: this.adults,
      noOfChildren: this.children,
      noOfInfants: this.infants,
      selectedDestination: null,
      selectedDestinationId: this.destinationId ? this.destinationId : "",
      startDate: this.inputStartDate
        ? this.inputStartDate
        : moment().toISOString(true),
      endDate: this.inputEndDate
        ? this.inputEndDate
        : moment().add(1, "days").toISOString(true),
      startDateRangeStart: moment().subtract(2, "years").toISOString(true),
      startDateRangeEnd: moment().add(5, "years").toISOString(true),
      endDateRangeStart: moment().subtract(2, "years").toISOString(true),
      endDateRangeEnd: moment().add(5, "years").toISOString(true),
      selectedAgentId: this.agentId ? this.agentId : "",
      department: this.departmentName,
      selectedInternalStatus: this.internalStatus,
      selectedInternalReference: this.internalReference,
      selectedClientReference: this.clientReference,
      selectedBookedBy: this.bookedById,
      selectedBrand: this.brand,
      selectedLeadSourceIds: this.leadSourceIds ? [...this.leadSourceIds] : [],
      showMoveItinerary: false,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    disableClientRef() {
      return !this.$store.getters.hasAccessTo("itineraries:client_ref", true);
    },
    showLeadSource() {
      return this.$store.getters.hasAccessTo("itineraries:lead_source");
    },
    leadSourceLabel() {
      return this.$store.getters.isCPS ? "Operations Team" : "Lead Source";
    },
    brandLabel() {
      return this.$store.getters.isCPS ? "Itinerary Destination" : "Brand";
    },
  },

  methods: {
    onBookedByChange(payload) {
      this.$emit("booked-by-change", payload);
    },
    onShowPaxUpdater() {
      this.$emit("showPaxUpdater");
    },
    onAgentEdit(payload) {
      this.$emit("editAgent", payload);
    },
    onMoveItineraryClick() {
      this.showMoveItinerary = true;
    },
    onStartDateSelected(date) {
      if (
        datesAreDiffernt(this.startDate, date) &&
        this.itineraryDurationIsValid(date, this.endDate)
      ) {
        this.startDate = date;
        const startDate = moment(date);
        const endDate = moment(this.endDate);
        if (startDate > endDate) {
          this.endDate = startDate.add("1", "days").toISOString(true);
        }
        this.endDateRangeStart = startDate.add(1, "days").toISOString(true);
        this.endDateRangeEnd = startDate.add(365, "days").toISOString(true);
        this.dispatchChange();
        this.$emit("startDateChange", date);
      }
    },
    itineraryDurationIsValid(startDate, endDate) {
      //http://tracker.globetrack.ie/issues/6334
      const start = moment(startDate).startOf("day");
      const end = moment(endDate).startOf("day");
      if (start.isValid() && end.isValid()) {
        if (end.diff(start, "days") > 42) {
          alert(
            "CAUTION! Your itinerary exceeds 42 days. Please check your itinerary dates."
          );
        }
      }
      return true;
    },
    onEndDateSelected(date) {
      if (
        datesAreDiffernt(this.endDate, date) &&
        this.itineraryDurationIsValid(this.startDate, date)
      ) {
        this.endDate = date;
        this.dispatchChange();
        this.$emit("endDateChange", date);
      }
    },
    onChange() {
      this.dispatchChange();
    },
    onAdultsChange(value) {
      const numValue = parseInt(value, 10) || 0;
      if (numValue < this.minAdults) {
        this.noOfAdults = String(this.minAdults);
      }
      this.dispatchChange();
    },
    onChildrenChange(value) {
      const numValue = parseInt(value, 10) || 0;
      if (numValue < this.minChildren) {
        this.noOfChildren = String(this.minChildren);
      }
      this.dispatchChange();
    },
    onInfantsChange(value) {
      const numValue = parseInt(value, 10) || 0;
      if (numValue < this.minInfants) {
        this.noOfInfants = String(this.minInfants);
      }
      this.dispatchChange();
    },
    onDestinationSelect(d) {
      this.selectedDestination = { ...d };
      if (d.brand != "") {
        this.selectedBrand = d.brand;
      }
      this.selectedDestinationId = d.id;
      this.dispatchChange();
    },
    onAgentSelect($event) {
      this.selectedAgentId = $event.id;
      this.$emit("agentChange", { ...$event });
      //this.dispatchChange();
    },
    onDepartmentSelect($event) {
      this.department = $event;
      this.$store.dispatch("setItineraryDepartment", this.department);
      this.dispatchChange();
      this.$emit("department-change", this.department);
    },
    dispatchChange() {
      this.$emit("onDetailsChange", {
        adults: String(this.noOfAdults),
        children: String(this.noOfChildren),
        infants: String(this.noOfInfants),
        destination: { id: this.selectedDestinationId },
        startDate: this.startDate,
        endDate: this.endDate,
        department: this.department,
        internalStatus: this.selectedInternalStatus,
        internalReference: this.selectedInternalReference,
        clientReference: this.selectedClientReference,
        bookedById: this.selectedBookedBy,
        brand: this.selectedBrand || "", //http://tracker.globetrack.ie/issues/5729
        leadSourceIds: this.selectedLeadSourceIds || [],
      });
    },
    onNewStartDate(newDate) {
      this.showMoveItinerary = false;
      this.$emit("newStartDate", newDate);
    },
    onMove(payload) {
      this.showMoveItinerary = false;
      this.$emit("move", payload);
    },
  },
  watch: {
    adults: function (val) {
      this.noOfAdults = val;
    },
    children: function (val) {
      this.noOfChildren = val;
    },
    infants: function (val) {
      this.noOfInfants = val;
    },
    agentId(val) {
      this.selectedAgentId = val;
    },
    departmentName: function (val) {
      this.department = val;
    },
    destinationId: function (val) {
      this.selectedDestinationId = val;
    },
    internalReference: function (val) {
      this.selectedInternalReference = val;
    },
    clientReference: function (val) {
      this.selectedClientReference = val;
    },
    internalStatus: function (val) {
      this.selectedInternalStatus = val;
    },
    inputStartDate: function (val) {
      this.startDate = val;
    },
    inputEndDate: function (val) {
      this.endDate = val;
    },
    bookedById(val) {
      this.selectedBookedBy = val;
    },
    brand(val) {
      this.selectedBrand = val;
    },
    leadSourceIds(val) {
      this.selectedLeadSourceIds = val ? [...val] : [];
    },
  },
  beforeDestroy() {
    const domain = this.$store.state.userConfig.domain;
    document.title = domain ? `VueTrip | ${domain}` : "VueTrip";
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderDetails.vue